import { TriggersEnum } from '../../../constants/Enums/BusinessRulesEnum';
import { LocalStorageService } from '../../../services/LocalStorageService';
import StringHelper from '../../../services/helpers/StringHelper';

export const TriggerHelper = {

  /** This function handle each trigger type attaches events after checking  conditions 
   * then calling  corresponding action
   * @function
   * @param {Object} trigger  triggers
   * @param {function} conditionCheck  recives condition arrays returns true or false 
   * @param {function} actions  fires action of trigger
   * 
   * @returns {bool}  true if condition pass check
   */
  triggersHandler(trigger = {}, conditionCheck, actions) {
    switch (trigger.type) {
      case TriggersEnum.EnterWebsiteTrigger:
        if (typeof conditionCheck === 'function') {
          this.addTriggerEvent(TriggerEvents.enterWebsite, () => {
            conditionCheck(trigger.conditions) && actions(trigger)
          })
          return true;
        }
        break;
      case TriggersEnum.PageOpenTrigger:
        if (typeof conditionCheck === 'function') {
          this.addTriggerEvent(TriggerEvents.pageOpen, () => {
            conditionCheck(trigger.conditions) && actions(trigger)
          })
          return true;
        }

        break;
      case TriggersEnum.LogoutTrigger:
        if (typeof conditionCheck === 'function') {
          this.addTriggerEvent(TriggerEvents.logout, () => {
            conditionCheck(trigger.conditions) && actions(trigger)
          })
          return true;
        }
        break;
      case TriggersEnum.LoginTrigger:
        if (typeof conditionCheck === 'function') {
          this.addTriggerEvent(TriggerEvents.login, () => {
            conditionCheck(trigger.conditions) && actions(trigger)
          })
          return true;
        }
        break;
      case TriggersEnum.SignUpTrigger:
        if (typeof conditionCheck === 'function') {
          this.addTriggerEvent(TriggerEvents.firstLogin, () => {
            setTimeout(() => {
              conditionCheck(trigger.conditions) && actions(trigger)
            }, 20)
          })
          return true;
        }
        break;
      default:
        break;
    }
    return false;
  },

  /** This Object contains trigger events methods
   * @Object
   */
  events: {
    /**  Enter  website First time event
    * @function
    */
    enterWebsite: (callback) => {
      callback();
    },
    /**  Page open event
    * @function
    */
    pageOpen: (callback) => {
      callback();
    },
    /**  User login event
      * @function
      */
    login: (callback) => {
      callback();
    },
    /** User logout event
      * @function
      */
    logout: (callback) => {
      callback();
    },
    /** User register event
      * @function
      */
    firstLogin: (callback) => {
      callback();
    }
  },

  /**
   * @function
   * @param {string} type  Custom event name
   * @param {function} callback  callback function
   * @param {Object} options  additional options
   */
  /** Adding  custom event on document
   * @returns {undefined} 
   */
  addTriggerEvent(type, callback, options) {
    this.startEvent(type);
    document.removeEventListener(type, this.events[type]);
    document.addEventListener(type, this.events[type].bind(TriggerHelper, callback));
  },
  /**
   * @function
   * Removing all  custom event on document
   */
  removeTriggerEvents() {
    Object.keys(TriggerEvents).forEach((type) => {
      document.removeEventListener(type, this.events[type]);
    })
  },

  /** Init custom event
    * @function
    * @param {string} type  Custom event name
    *
    * @returns {Event} object
    */
  startEvent(type, data) {
    return new CustomEvent(type, { detail: data });
  },

  /** Triggers custom event
    * @function
    * @param {string} type  Custom event name 
    */
  triggerEvent(type, data) {
    switch (type) {
      case TriggerEvents.logout:
        const storageData = LocalStorageService.get(`businessRulesTrigger`);
        (!storageData || !storageData[TriggerEvents.logout]) && LocalStorageService.set(`businessRulesTrigger`, { ...(storageData ? storageData : {}), [TriggerEvents.logout]: true })
        break;
      default:
        break;
    }
    document.dispatchEvent(this.startEvent(type, data));
  },
  /** Triggers custom event
  * @function
  * @param {string} name  Custom event name
  * @param {string} category  Custom event category
  * @param {string} action  Custom event action
  */
  triggerCustomEvent(name, category, action, data) {
    const deteils = TriggerHelper.generateEventDeteils(name, category, action);
    data = {...data,  ...deteils}
    const type = 'dgb-event'
    document.dispatchEvent(this.startEvent(type, data));
  },
  /** Generates event name
  * @function
  * @param {string} name  Custom event name
  * @param {string} category  Custom event category
  * @param {string} action  Custom event action
  * 
  * @returns {object} Generated event deteils
  */
  generateEventDeteils: (name, category, action) => {
    const eventPrefix = 'dgb';
    const divider = '-';
    category = StringHelper.camelCaseToKebabCase(category);
    name = StringHelper.camelCaseToKebabCase(name?.toLowerCase());
    const id =`${eventPrefix}${divider}${category ? `${category}${divider}` : ''}${name}${action ? `${divider}${action}` : ''}`;
    return {id, name, category, action}
  }
}

export const TriggerEvents = {
  pageOpen: 'pageOpen',
  enterWebsite: 'enterWebsite',
  login: 'login',
  logout: 'logout',
  regStarted: 'regStarted',
  regConfirmed: 'regConfirmed',
  firstLogin: 'firstLogin',
  depositStarted: 'depositStarted',
  depositInitiated: 'depositInitiated',
  withdrawalInitiated: 'withdrawalInitiated',
  withdrawalStarted: 'withdrawalStarted',
  selfExclusionConfirmed: 'selfExclusionConfirmed',
  onMenuItemClick: 'onMenuItemClick',
  languageChange: 'languageChange'
}